import React, { useEffect, useState, useRef } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 2
  });
  const sectionRef = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (!sectionRef.current) return;
    const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), {
      rootMargin: '100px'
    });
    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [isVisible]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section ref={sectionRef} className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(254,242,242) 0%, rgb(254,242,242) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-91">
      <div className="mx-auto max-w-4xl text-center" data-id="element-92">
        {/* Heading */}
        <h2 className="text-lg sm:text-2xl font-black text-gray-900 m-0 mb-6" data-id="element-93">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        {/* Timer */}
        <div className="mb-4" data-id="element-94">
          <div className="flex items-center justify-center gap-2" data-id="element-95">
            <div className="flex flex-col items-center" data-id="element-96">
              <span className="text-4xl sm:text-6xl font-black tabular-nums text-[rgb(255,68,68)]" data-id="element-97">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500" data-id="element-98">
                hs
              </span>
            </div>
            <span className="mb-4 text-4xl sm:text-6xl font-black text-[rgb(255,68,68)]" data-id="element-99">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-100">
              <span className="text-4xl sm:text-6xl font-black tabular-nums text-[rgb(255,68,68)]" data-id="element-101">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500" data-id="element-102">
                min
              </span>
            </div>
            <span className="mb-4 text-4xl sm:text-6xl font-black text-[rgb(255,68,68)]" data-id="element-103">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-104">
              <span className="text-4xl sm:text-6xl font-black tabular-nums text-[rgb(255,68,68)]" data-id="element-105">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500" data-id="element-106">
                seg
              </span>
            </div>
          </div>
        </div>

        {/* Price Warning */}
        <p className="font-bold text-gray-900 m-0 mb-8 text-[15px]" data-id="element-107">
          Después sube{' '}
          <span className="font-black text-red-600" data-id="element-108">$15.000 ARS</span> y no
          vuelve a bajar.
        </p>

        {/* Progress Bar */}
        <div className="mb-4 mx-auto max-w-xl" data-id="element-109">
          <div className="mb-1 flex items-center justify-between" data-id="element-110">
            <span className="text-xs font-bold text-red-600" data-id="element-111">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold text-gray-900" data-id="element-112">
              Quedan pocos
            </span>
          </div>
          <div className="h-3 w-full overflow-hidden bg-gray-200 rounded-full" data-id="element-113">
            <div className="h-3 rounded-full" style={{
            width: '68%',
            backgroundImage: 'linear-gradient(to right, rgb(255,0,0), rgb(255,102,0))'
          }} data-id="element-114" />
          </div>
          <p className="text-right text-[10px] text-gray-500 mt-1 mb-0" data-id="element-115">
            68% de los cupos tomados
          </p>
        </div>
      </div>
    </section>;
}